import { mapGetters } from 'vuex'
import { bankInfosFields, contactInfosFields } from '@/utils/person.utils'
import { sortBy } from '@/utils/common.utils'
import ApiService from '@/services/ApiService'

export default {
  data() {
    return {
      bankInfosFields,
      contactInfosFields,
    }
  },
  computed: {
    ...mapGetters({
      authorization: 'admin/authorization',
      customerFileStatus: 'admin/customerFileStatus',
      currentCustomer: 'admin/currentCustomer',
      currentCustomerFile: 'admin/currentCustomerFile',
      currentControls: 'admin/currentControls',
      currentFields: 'admin/currentFields',
      personControlId: 'admin/personControlId',
      adminFormErrors: 'admin/formErrors',
      adminFormAlerts: 'admin/formAlerts',
    }),
    isReadyToValidate: (state) => {
      const controls = state.currentControls
      if (!controls.checks) {
        return false
      }

      const anyFalsyIndex = Object.values(controls.checks).findIndex((value) => !value)

      return anyFalsyIndex < 0
    },
  },
  methods: {
    async refreshCustomerFields() {
      this.toggleAppLoader(true)

      const currentCustomer = await ApiService.getPerson(this.$route.params.id)
      const personControls = currentCustomer.data.person_controls
      const personControl = personControls && personControls.length > 0 ? personControls[0] : null
      const controlChecks = personControl ? personControl.checks : {}
      const controlId = personControl ? personControl.id : ''

      const currentCustomerFileId = currentCustomer.data.customer_files[0].id
      const currentCustomerFile = await ApiService.getCustomerFile(currentCustomerFileId)
      const missingAttributes = currentCustomer.data.meta.missing_attributes
      const warnings = []
      missingAttributes.forEach((fieldName) => {
        // eslint-disable-next-line no-prototype-builtins
        if (!warnings.hasOwnProperty(fieldName)) {
          const label = this.$t(`main.enums.fields.${fieldName}`)
          warnings.push(this.$t('main.enums.error.missing-field', { label, }))
        }
      })
      this.$store.commit('admin/setCurrentCustomer', currentCustomer.data)
      // @todo ndm : problem with the config absence when calling for setConfigFields order wise after page reload
      this.$store.commit('common/setConfigFields', currentCustomer.data.person_kind)
      this.$store.commit('admin/setCurrentControls', personControl)
      this.$store.commit('admin/setCurrentCustomerFile', currentCustomerFile.data)
      this.$store.commit('admin/setFormAlerts', warnings)

      this.fetchCustomerFields(
        currentCustomer.data,
        controlChecks,
        this.requiredAttributes,
        this.optionalAttributes,
        controlId
      )
      this.toggleAppLoader(false)
    },
    fetchCustomerFields(customer, controls, requiredAttributes, optionalAttributes, personControlId) {
      const allFields = requiredAttributes.concat(optionalAttributes)
      const tab = []

      allFields.forEach((item) => {
        tab.push({
          label: item,
          value: customer[item],
          control: item in controls,
          valid: controls[item],
          type: this.findType(item),
        })
      })

      const fields = sortBy(tab, 'type', true)

      this.$store.commit('admin/setCustomerFields', fields)
      this.$store.commit('admin/setPersonControlId', personControlId)
    },
    findType(field) {
      if (bankInfosFields.includes(field)) {
        return 'bank_infos'
      } else if (contactInfosFields.includes(field)) {
        return 'contact_infos'
      } else {
        return 'personal_infos'
      }
    },
  },
}
